export enum SettingType {
    COURSE_LEVEL = 'COURSE_LEVEL',
    TEST_RESULT = 'TEST_RESULT',
}
